import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

// TODO this needs to be an @adornis/address address. Refactor asap. I have done all the other places, but not sure enough which consequences are behind this one.
@Entity()
export class SmartTeamsLocation extends AdornisEntity {
  static override _class = 'SmartTeamsLocation';

  @Field(() => String)
  street: Maybe<string>;

  @Field(() => String)
  number: Maybe<string>;

  @Field(() => String)
  city: Maybe<string>;

  @Field(() => String)
  zipCode: Maybe<string>;

  @Field(() => String)
  country: Maybe<string>;

  @Field(() => Float)
  lat: Maybe<number>;

  @Field(() => Float)
  lng: Maybe<number>;
}
